import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const ndlDeploymentsSlice = createCrudSlice({
  name: 'ndlDeployments',
  idKey: 'id',
})

export const NdlDeploymentsActions = ndlDeploymentsSlice.actions

export const NdlDeploymentsSelectors = {
  ...createCrudSelectors({ name: 'ndlDeployments', idKey: 'id' }),
}

export default ndlDeploymentsSlice.reducer
